import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>vocatus</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            vocat–
            <strong>us</strong>
          </td>
          <td>
            vocat–
            <strong>a</strong>
          </td>
          <td>
            vocat–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            vocat–
            <strong>i</strong>
          </td>
          <td>
            vocat–
            <strong>ae</strong>
          </td>
          <td>
            vocat–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            vocat–
            <strong>o</strong>
          </td>
          <td>
            vocat–
            <strong>ae</strong>
          </td>
          <td>
            vocat–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            vocat–
            <strong>um</strong>
          </td>
          <td>
            vocat–
            <strong>am</strong>
          </td>
          <td>
            vocat–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            vocat–
            <strong>o</strong>
          </td>
          <td className="bor-bot">
            vocat–
            <strong>a</strong>
          </td>
          <td className="bor-bot">
            vocat–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            vocat–
            <strong>i</strong>
          </td>
          <td>
            vocat–
            <strong>ae</strong>
          </td>
          <td>
            vocat–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            vocat–
            <strong>orum</strong>
          </td>
          <td>
            vocat–
            <strong>arum</strong>
          </td>
          <td>
            vocat–
            <strong>orum</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            vocat–
            <strong>is</strong>
          </td>
          <td>
            vocat–
            <strong>is</strong>
          </td>
          <td>
            vocat–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            vocat–
            <strong>os</strong>
          </td>
          <td>
            vocat–
            <strong>as</strong>
          </td>
          <td>
            vocat–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            vocat–
            <strong>is</strong>
          </td>
          <td>
            vocat–
            <strong>is</strong>
          </td>
          <td>
            vocat–
            <strong>is</strong>
          </td>
        </tr>
      </table>
    </div>
    <p>
      <Letop>
        Het rijtje van het ppp gaat dus volgens het rijtje van{" "}
        <a href="bijvoeglijk-naamwoord">
          <strong>longus</strong>
        </a>
        .
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/ppp.js